import { ReactNode } from "react";
import { Box, Grid2, Toolbar } from "@mui/material";
import { useLocation } from "react-router-dom";
import TopNavigation from "./TopNavigation";
import SideNavigation from "./SideNavigation";
import { useIsDesktopLayout } from "../../../hooks/useIsDesktopLayout";
import useDrawerStore from "../../../setup/store/useDrawerStore";
import ErrorBoundary from "../../common/ErrorBoundary";

interface Props {
  children: ReactNode;
}

const drawerWidth = 250;

const RootLayout = ({ children }: Props) => {
  const isMediumScreen = useIsDesktopLayout();
  const { pathname } = useLocation();

  const { state: open, toggle } = useDrawerStore();

  return (
    <Grid2 container>
      <TopNavigation />
      <SideNavigation open={open} onChange={toggle} width={drawerWidth} />
      <Box
        component="main"
        sx={{ flexGrow: 1, width: "100%" }}
        pl={isMediumScreen ? `${drawerWidth}px` : ""}
      >
        <Toolbar />
        <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>
      </Box>
    </Grid2>
  );
};

export default RootLayout;
